var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-dark m-0 p-4 display-4 d-flex justify-content-center align-items-center"},[_vm._t("default",function(){return [(_vm.icon)?_c('i',{staticClass:"fa-fw fa-2x fa-spin text-primary mr-4",class:_vm.icon}):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.message))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }